<mat-card
    appearance="outlined"
    [routerLink]="routerPath"
    [state]="{ navigatedBy: EventTrackerNavigationReasons.StartPageCardClick }"
    [class]="cardClass || ''"
    [ngClass]="{
        'cursor-pointer': !!this.routerPath,
    }"
>
    <mat-card-header [class]="headerClass">
        <mat-card-title [class]="titleClass || ''" [ngClass]="{ 'text-gray-300': !this.routerPath }">
            <mat-icon [class]="iconClass" [fontSet]="'material-symbols-rounded'">{{ iconName }} </mat-icon>
            {{ title }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content [class]="contentClass || ''" [ngClass]="{ 'text-gray-300': !this.routerPath }">
        {{ content }}
    </mat-card-content>
</mat-card>
